import { Component, OnInit } from '@angular/core';
import { PageRolesService } from '../../Service/page-roles.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NbDialogService, NbToastrService } from '@nebular/theme';
import { DomSanitizer } from '@angular/platform-browser';
import { PageRolesDetailsComponent } from '../page-roles-details/page-roles-details.component';
import { AddPageRolesComponent } from '../add-page-roles/add-page-roles.component';
import { BaseComponent } from '../../../../shared/Components/base/base.component';
import { Page } from '../../Model/pageRoles';
import { PagingService } from '../../../../shared/Services/PagingService';
import { DeleteConfirmationComponent } from '../../../delete-confirmation/delete-confirmation.component';

@Component({
  selector: 'get-page-roles',
  templateUrl: './get-page-roles.component.html',
  styleUrls: ['./get-page-roles.component.scss']
})
export class GetPageRolesComponent extends BaseComponent implements OnInit {

  dateTo: string;
  dateFrom: string;
  form: FormGroup;
  constructor(
    public service: PageRolesService,
    route: Router,
    private fb: FormBuilder,
    private diag: NbDialogService,
    private toast: NbToastrService,
    public sanitizer: DomSanitizer,
    private paging: PagingService
  ) {
    super(route, service, null, '', diag);
  }

  ngOnInit() {
    this.intitForm();
    this.loadEntities();
  }

  getLabelData(text) {
    return this.sanitizer.bypassSecurityTrustHtml(text);
  }

  intitForm() {
    this.form = this.fb.group({
      titleAR: [''],
    });
  }
  setPage(page: number) {
    this.finishLoading = false;
    this.paging.setPage(page, this.pagingModel, this.service);
    this.finishLoading = true;
  }
  handleSearch() {
    if (!this.form.value.titleAR && !this.dateFrom && !this.dateTo) {
      this.toast.danger('برجاء اختيار العنوان  لاتمام عملية البحث', 'رساله تحذيرية');
      return;
    }

    let serchTermArr = [];

    if (this.form.value.titleAR) {
      serchTermArr.push(`titleAR:${this.form.value.titleAR.trim()}`);
    }

    this.loadEntitiesWithFilter(serchTermArr.join(','));
  }
  clearFilter() {
    this.dateFrom = '';
    this.dateTo = '';
    this.form.controls['titleAR'].setValue('');
    this.loadEntitiesWithFilter('');
  }

  add() {
    //  const copymodel = {...model}
    this.dialog
      .open(AddPageRolesComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          // model: copymodel,
          isEdit: false,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') {
          this.toast.show('تم الاضافة بنجاح', '', { status: 'success', duration: 3000 });
          this.loadEntities();
        }
      });
  }

  delete(id) {
    this.diag.open(DeleteConfirmationComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        id: id,
        service: this.service,
        url:this.route.url
      },
    });
  }
  
  detail(model) {
    this.diag.open(PageRolesDetailsComponent, {
      dialogClass: 'custom-dialog-height',
      context: {
        model: model
      },
    });
  }

  update(models) {
    const copymodel = {...models}
    this.diag
      .open(AddPageRolesComponent, {
        dialogClass: 'custom-dialog-height',
        context: {
          model: copymodel,
          isEdit: true,
        },
      })
      .onClose.subscribe((res) => {
        if (res === 'true') this.loadEntities();
      });
  }
}
